import ajax from "@/lib/ajax";
import { MessageBox } from 'element-ui';

function getOtherStateLabel(status) {
    const statusObj = {
        0: " ● 已下线",
        1: " ● 已上线"
    };
    return statusObj[status];
}

function getColumnBtns(status) {
    const columnsBtn = [
        {
            label: "删除",
            value: "del"
        }
    ];
    if (status == 1) {
        columnsBtn.push({
            label: "下线",
            value: "offline"
        });
    } else {
        columnsBtn.push({
            label: "上线",
            value: "online"
        });
    }
    return columnsBtn;
}

// 请求RPA列表
export async function queryRpaList(reqData) {
    const request = {
        game_id: reqData.gameId,
        kw: reqData.searchText || "",
        sort: reqData.order,
        status: reqData.status,
        page: reqData.page || 1,
        page_size: reqData.size || 10
    };

    const result = await ajax.get("/xiaoyue-operation/rpa/list", request);
    const { count, offline_count, online_count, list } = result;

    const newList = list.map(item => {
        return {
            ...item,
            name: item.rpa_name,
            triggerCount: item.trigger_count,
            editTime: item.edit_time,
            status: { text: getOtherStateLabel(item.status), color: getOtherStateLabel(item.status) === " ● 已下线" ? "#52596F" : "" },
            operator: getColumnBtns(item.status),
        };
    });
    return {
        count,
        offline_count,
        online_count,
        list: newList,
    };
}

// 创建rpa
export async function createRpa(reqData) {
    const result = ajax.post("/xiaoyue-operation/rpa/add", reqData);
    return result;
}

// 修改rpa状态（批量||单个）
export async function updateRpa(reqData) {
    const params = {
        rpa_ids: reqData.rpaIds,
        status: reqData.status,
        game_id: reqData.gameId,
    };
    try {
        const result = await ajax.post("/xiaoyue-operation/rpa/status/update", params);
        return result;
    } catch (error) {
        MessageBox.confirm(`RPA上线失败: ${error.response.data.err_msg}`, "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
        });
        return error;
    }
}

// 删除rpa（批量||单个）
export async function deleteRpa(reqData) {
    const params = {
        game_id: reqData.gameId,
        rpa_ids: reqData.rpaIds
    };
    const result = await ajax.post("/xiaoyue-operation/rpa/delete", params);
    return result;
}
